export const QUESTION_TYPE_LABELS = {
  SINGLE_CORRECT: "Single correct",
  MCQ: "Single correct",
  MULTI_CORRECT: "Multiple correct",
  NUMERICAL: "Numerical",
  MATCH: "Match the following",
  PARAGRAPH: "Paragraph",
  RANGE: "Range",
};

/*
 * Match the following. Options are stored with the keys A–F (Column I) and
 * P–U (Column II) — the API, CSV import and marking all use those — but the
 * paper shows Column I as P, Q, R, S, T, U and Column II as I, II, III, IV, V, VI.
 */
export const MATCH_COLUMN_I_KEYS = ["A", "B", "C", "D", "E", "F"];
export const MATCH_COLUMN_II_KEYS = ["P", "Q", "R", "S", "T", "U"];

const MATCH_LABELS = {
  A: "P", B: "Q", C: "R", D: "S", E: "T", F: "U",
  P: "I", Q: "II", R: "III", S: "IV", T: "V", U: "VI",
};

/** The label shown for a stored match key: "A" → "P", "R" → "III". */
export const matchLabel = (key) => {
  const text = String(key ?? "").trim().toUpperCase();
  return MATCH_LABELS[text] || text;
};

/** "A-P, B-Q" (stored keys) → "P → I, Q → II" */
export const formatMatchAnswer = (answer) =>
  String(answer ?? "")
    .split(/[,;]/)
    .map((pair) => pair.trim())
    .filter(Boolean)
    .map((pair) => {
      const m = pair.match(/^([A-Z])\s*(?:->|-|→|>|:)\s*([A-Z])$/i);
      return m ? `${matchLabel(m[1])} → ${matchLabel(m[2])}` : pair;
    })
    .join(", ");
